import React, { useState, useEffect } from "react";
import SvgLine from "./components/BrickWall"; // Animation Component
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from "./pages/homepage"; // Main Home Component

const App = () => {
  const [showHome, setShowHome] = useState(false);

  useEffect(() => {
    // Wait for animation to finish (8 seconds)
    const timer = setTimeout(() => setShowHome(true), 8000);

    return () => clearTimeout(timer);
  }, []);

  return <>{showHome ? <Home /> : <SvgLine />}</>;
};

export default App;
